//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faLinkedin, faTwitterSquare, faInstagramSquare } from '@fortawesome/free-brands-svg-icons'
import { faGlobeEurope, faPenSquare } from '@fortawesome/free-solid-svg-icons'
import WebPresenceItem from './WebPresenceItem.vue'

export default {
  name: 'WebPresenceGroup',
  components: {
    WebPresenceItem,
    FontAwesomeIcon
  },
  props: {
    freelancer: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    linkedinIcon () {
      return faLinkedin
    },
    websiteIcon () {
      return faGlobeEurope
    },
    twitterIcon () {
      return faTwitterSquare
    },
    instagramIcon () {
      return faInstagramSquare
    },
    blogIcon () {
      return faPenSquare
    },
    websiteUrl () {
      return this.checkPrefix(this.freelancer.web)
    },

    blogUrl () {
      return this.checkPrefix(this.freelancer.blog)
    },

    linkedinUrl () {
      return this.checkPrefix(this.freelancer.linkedin)
    },

    twitterUrl () {
      return this.checkPrefix(this.freelancer.twitter)
    },

    instagramUrl () {
      return this.checkPrefix(this.freelancer.instagram)
    }
  },
  methods: {
    checkPrefix (url) {
      const pattern = /^((http|https|ftp):\/\/)/

      if (!pattern.test(url)) {
        return `https://${url}`
      }

      return url
    }
  }
}
